import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Overlay } from 'src/components/Overlay';
import SingleItem from 'src/layouts/SingleItem';
import { AssessmentDetailsProvider } from './AssessmentDetailsContext';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import { SubmissionDetails } from './SubmissionDetailsTab';
import { AssessmentSidebar } from './AssessmentSidebar';
import AboutTab from './AboutTab';
import { ProxyBanner } from 'src/components/ProxyUser/ProxyUser';

export const ASSESSMENT_DETAILS_TAB = {
  SUBMISSION: 'Submission',
  ABOUT: 'About',
} as const;

export type AssessmentDetailsTab = (typeof ASSESSMENT_DETAILS_TAB)[keyof typeof ASSESSMENT_DETAILS_TAB];

export const reviewStatusMap: Record<string, string> = {
  approve: 'Publish',
  reject: 'Reject'
};

const renderTab = (
  tab: AssessmentDetailsTab,
) => {
  switch (tab) {
    case ASSESSMENT_DETAILS_TAB.SUBMISSION:
      return <SubmissionDetails />;
    case ASSESSMENT_DETAILS_TAB.ABOUT:
      return <AboutTab />;
    default:
      return null;
  }
};

const Assessment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [activeTab, setActiveTab] = useState<AssessmentDetailsTab>(
    ASSESSMENT_DETAILS_TAB.SUBMISSION
  );
  const { isInviteRequestAccepted: isAssessmentRequestAccepted } = useAssessmentData();

  const closeItem = () => {
    if (location.key !== 'default') {
      return navigate(`/app/assessments?${searchParams.toString()}`);
    }
    return navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const invitedAssessmentTab = Object.values(ASSESSMENT_DETAILS_TAB).filter(tab => tab === ASSESSMENT_DETAILS_TAB.SUBMISSION)

  return (
    <AssessmentDetailsProvider
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    >
      <Overlay>
        <ProxyBanner />
        <SingleItem width="100%">
          <SingleItem.MainArea>
            <SingleItem.Navigation>
              {Object.values(!isAssessmentRequestAccepted() ? invitedAssessmentTab : ASSESSMENT_DETAILS_TAB).map(tab => (
                <SingleItem.Tab
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  isActive={activeTab === tab}
                >
                  {tab}
                </SingleItem.Tab>
              ))}
            </SingleItem.Navigation>
            <SingleItem.Content
              size={'normal'}
            >
              {renderTab(activeTab)}
            </SingleItem.Content>
          </SingleItem.MainArea>

          <SingleItem.Sidebar>
            <AssessmentSidebar
              setActiveTab={setActiveTab}
              onClose={closeItem}
            />
          </SingleItem.Sidebar>
        </SingleItem>
      </Overlay>
    </AssessmentDetailsProvider>
  );
};

export default Assessment;
